module.exports = __webpack_public_path__ + "images/aba3bf45bc5d12eed256c4dfc73b5482.svg";